import { ref } from 'vue'
import { useLocale } from '@/composables/useLocale'
import { fetchDocCategory } from '@/api/docs'
import type { DocArticleListItem } from '@/types/docs'

export function useDocCategory() {
  const { currentLocale } = useLocale()

  const articles = ref<DocArticleListItem[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const notFound = ref(false)

  async function fetch(category: string): Promise<void> {
    loading.value = true
    error.value = null
    notFound.value = false
    try {
      articles.value = await fetchDocCategory(category, currentLocale.value)
    } catch (e: unknown) {
      if (isNotFoundError(e)) {
        notFound.value = true
      } else {
        error.value = 'docs.category.error'
      }
    } finally {
      loading.value = false
    }
  }

  return { articles, loading, error, notFound, fetch }
}

function isNotFoundError(e: unknown): boolean {
  return (
    typeof e === 'object' &&
    e !== null &&
    'response' in e &&
    typeof (e as { response: { status: number } }).response === 'object' &&
    (e as { response: { status: number } }).response.status === 404
  )
}
